module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_18.335592dd.png";